import React, { useMemo } from 'react'
import { useRouter } from 'next/router'
import PropTypes from 'prop-types'

import dynamic from 'next/dynamic'

import styles from './style.module.scss'
import placeholderFlag from 'assets/images/placeholder/team-placeholder.svg'
import { convertDate, dateCheck } from '@shared-submodule/utils'
import { allRoutes } from '@shared-submodule/sm-constants/allRoutes'
import { S3_PREFIX } from '@shared-submodule/sm-constants'
import CustomLink from '@shared/components/customLink'
import useWindowSize from '@shared/hooks/windowSize'
import useStatus from '@shared-submodule/sm-hooks/useStatus'
import { ENUM_CRICKET_MATCH_PAGES } from '@shared-submodule/sm-enum'

const MyImage = dynamic(() => import('@shared/components/myImage'))

const FixturesItems = ({ fixture, id, isSeriesShow, seriesUrls }) => {
  const router = useRouter()
  const [width] = useWindowSize()
  const { sStatusStr, sStatus, sFormat } = useStatus(fixture)
  const rewriteURLs = useMemo(() => {
    const urls = {}
    fixture?.oMatchSeos?.oSeo?.forEach(data => {
      if (data?.sSlug) {
        urls[ENUM_CRICKET_MATCH_PAGES[data.eSubType]] = `/${data?.sSlug}`
      }
    })
    urls.home = `/${fixture?.oSeo?.sSlug}`
    return urls
  }, [sStatusStr, fixture])
  const countCharSubTitle = sFormat?.length + fixture?.sSubtitle?.length
  const countCharTitle = fixture?.oSeries?.sTitle?.length + fixture?.oSeries?.sSeason?.length
  const handleCard = (value, chkCard = 0, event) => {
    if (chkCard === 1) {
      router.push(allRoutes.matchDetail(value))
      event.stopPropagation()
    } else {
      if (sStatusStr === 'live') router.push(rewriteURLs?.commentary || rewriteURLs?.home)
      else if (sStatusStr === 'scheduled') router.push(rewriteURLs?.home || allRoutes.matchDetail(value?.oSeo?.sSlug))
      else if (sStatusStr === 'completed' || sStatusStr === 'cancelled') router.push(rewriteURLs?.['full-scorecard'] || rewriteURLs?.home)
    }
  }

  return (
    <div className={`${styles.fixturesList}`} id={id}>
      <div className={`${styles.fixturesItem} common-box`}>
        <div className={`${styles.head} xsmall-text`} onClick={e => handleCard(fixture, 0, e)}>
          <p>
            {sStatusStr === 'completed' && <span className={`${styles.pr} success-text font-bold ${styles.dotSymbol}`}>{sStatus}</span>}
            {sStatusStr === 'live' && (
              <span className={`${styles.pr} danger-text font-bold text-capitalize ${styles.dotSymbol}`}>
                <span>{sStatusStr} </span>
              </span>
            )}
            {sStatusStr === 'scheduled' && <span className={`${styles.pr} theme-text font-bold ${styles.dotSymbol}`}>{sStatus} </span>}
            {sStatusStr === 'cancelled' && <span className={`${styles.pr} danger-text font-bold ${styles.dotSymbol}`}>{sStatus} </span>}
            {/* <span
              className={`d-inline-flex align-items-center me-1 ${sStatusStr === 'completed' ? styles.completed : sStatusStr === 'live' || sStatusStr === 'cancelled' ? styles.live : ''
                }`}
            >
              {sStatusStr !== 'live' && sStatus}
            </span> */}
            <span className={`${styles.matchTime} font-semi`}>{fixture?.sSubtitle && '' + fixture?.sSubtitle} </span>
            {isSeriesShow && (
              <span>
                {countCharSubTitle + countCharTitle > 60 && width > 767 ? (
                  <span
                    className={styles.hoverA}
                    onClick={e => handleCard(fixture?.oSeries?.oCategory?.oSeo?.sSlug || fixture?.oSeries?.oSeo?.sSlug, 1, e)}>
                    {fixture?.oSeries?.sTitle && ' - ' + fixture?.oSeries?.sTitle?.slice(0, 60 - countCharSubTitle) + '...'}
                  </span>
                ) : (
                  <span
                    className={styles.hoverA}
                    onClick={e => handleCard(fixture?.oSeries?.oCategory?.oSeo?.sSlug || fixture?.oSeries?.oSeo?.sSlug, 1, e)}>
                    {fixture?.oSeries?.sTitle && ` - ${fixture?.oSeries?.sTitle}`}
                    {fixture?.oSeries?.sSeason && ` - ${fixture?.oSeries?.sSeason}`}
                  </span>
                )}
              </span>
            )}
          </p>
          <div className="d-flex flex-wrap flex-md-column xsmall-text">
            <p className={`${styles.ellipsis} font-semi text-dark`}>
              <span className={`text-muted ${fixture?.oVenue?.sName?.split(',')[0] !== '' && styles.dotSymbol} mr-01`}>
                {convertDate(dateCheck(fixture?.dStartDate))}
              </span>
              <span className="text-muted"> {fixture?.oVenue?.sName?.split(',')[0]}</span>
            </p>
          </div>
        </div>
        <div className={`${styles.content} mt-3`}>
          <div className={`${styles.teams} font-bold`} onClick={e => handleCard(fixture, 0, e)}>
            <div className={`${styles.team} d-flex align-items-center justify-content-between mb-2 pb-md-1`}>
              <div className={`${styles.name} d-flex align-items-center`}>
                <div className={`${styles.icon}`}>
                  <MyImage
                    src={
                      fixture?.oTeamScoreA?.oTeam?.oImg?.sUrl ? `${S3_PREFIX}${fixture?.oTeamScoreA?.oTeam?.oImg?.sUrl}` : placeholderFlag
                    }
                    placeholderImage={placeholderFlag}
                    alt={fixture?.oTeamScoreA?.oTeam?.sTitle}
                    errorImage={placeholderFlag}
                    layout="responsive"
                    width="20"
                    height="20"
                    autoRadiusImage
                    placeholder={placeholderFlag?.src}
                    sizes="(max-width: 767px) 40px, (max-width: 991px) 40px, (max-width: 1190px) 200px, 40px"
                  />
                </div>
                {sStatusStr !== 'scheduled' && sStatusStr !== 'cancelled' ? (
                  <p>
                    {fixture?.oTeamScoreA?.oTeam?.sAbbr || fixture?.oTeamScoreA?.oTeam?.sTitle}
                    {/* {(sStatusStr === 'completed' && fixture?.oTeamScoreA?.oTeam?._id === fixture?.oWinner?._id) && (
                      <span className={`${styles.winner} ms-2 d-inline-block`}><CupIcon /></span>
                    )} */}
                  </p>
                ) : (
                  <p>{fixture?.oTeamScoreA?.oTeam?.sTitle}</p>
                )}
              </div>
              <p className={`${styles.score} ${fixture?.oTeamScoreA?.oTeam?._id === fixture?.oWinner?._id ? 'text-success' : ''}`}>
                {sStatusStr === 'live' &&
                  fixture?.nLatestInningNumber === 1 &&
                  (fixture?.oTeamScoreA?.sScoresFull ? (
                    <span className={'theme-text'}>{fixture?.oTeamScoreA?.sScoresFull}</span>
                  ) : (
                    'Yet To Bat'
                  ))}
                {sStatusStr === 'live' &&
                  fixture?.nLatestInningNumber > 1 &&
                  (fixture?.oTeamScoreA?.sScoresFull?.includes('*') ? (
                    <span className={'theme-text'}>{fixture?.oTeamScoreA?.sScoresFull}</span>
                  ) : (
                    fixture?.oTeamScoreA?.sScoresFull
                  ))}
                {(sStatusStr === 'completed' || sStatusStr === 'cancelled') && fixture?.oTeamScoreA?.sScoresFull}
              </p>
            </div>
            <div className={`${styles.team} d-flex align-items-center justify-content-between`}>
              <div className={`${styles.name} d-flex align-items-center`}>
                <div className={`${styles.icon}`}>
                  <MyImage
                    src={
                      fixture?.oTeamScoreB?.oTeam?.oImg?.sUrl ? `${S3_PREFIX}${fixture?.oTeamScoreB?.oTeam?.oImg?.sUrl}` : placeholderFlag
                    }
                    placeholderImage={placeholderFlag}
                    errorImage={placeholderFlag}
                    layout="responsive"
                    width="20"
                    height="20"
                    autoRadiusImage
                    alt={fixture?.oTeamScoreB?.oTeam?.sTitle}
                    placeholder={placeholderFlag?.src}
                    sizes="(max-width: 767px) 40px, (max-width: 991px) 40px, (max-width: 1190px) 200px, 40px"
                  />
                </div>
                {sStatusStr !== 'scheduled' && sStatusStr !== 'cancelled' ? (
                  <p>
                    {fixture?.oTeamScoreB?.oTeam?.sAbbr || fixture?.oTeamScoreB?.oTeam?.sTitle}
                    {/* {(sStatusStr === 'completed' && fixture?.oTeamScoreB?.oTeam?._id === fixture?.oWinner?._id) && (
                      <span className={`${styles.winner} ms-2 d-inline-block`}><CupIcon /></span>
                    )} */}
                  </p>
                ) : (
                  <p>{fixture?.oTeamScoreB?.oTeam?.sTitle}</p>
                )}
              </div>
              <p className={`${styles.score} ${fixture?.oTeamScoreB?.oTeam?._id === fixture?.oWinner?._id ? 'text-success' : ''}`}>
                {sStatusStr === 'live' &&
                  fixture?.nLatestInningNumber === 1 &&
                  (fixture?.oTeamScoreB?.sScoresFull ? (
                    <span className={'theme-text'}>{fixture?.oTeamScoreB?.sScoresFull}</span>
                  ) : (
                    'Yet To Bat'
                  ))}
                {sStatusStr === 'live' &&
                  fixture?.nLatestInningNumber > 1 &&
                  (fixture?.oTeamScoreB?.sScoresFull?.includes('*') ? (
                    <span className={'theme-text'}>{fixture?.oTeamScoreB?.sScoresFull}</span>
                  ) : (
                    fixture?.oTeamScoreB?.sScoresFull
                  ))}
                {(sStatusStr === 'completed' || sStatusStr === 'cancelled') && fixture?.oTeamScoreB?.sScoresFull}
              </p>
            </div>
          </div>
          <div className={`${styles.info} my-2 py-1 py-md-0 my-md-3`}>
            <p className={`d-flex align-items-start ${styles.matchStatus} text-${sStatusStr === 'completed' ? 'success' : sStatusStr === 'live' || sStatusStr === 'cancelled' ? 'danger' : 'primary'
              }`}
            >
              {fixture?.sStatusNote && fixture?.sStatusNote?.trim() && sStatusStr !== 'live' ? fixture?.sStatusNote : (fixture?.sStatusNote?.trim())}
            </p>
          </div>
          <div className={`${styles.btnList} d-flex font-semi xsmall-text`}>
            {sStatusStr === 'scheduled' ? (
              <p className="flex-grow-1 mx-1">
                <CustomLink href={allRoutes.matchDetail(fixture?.oSeo?.sSlug)} prefetch={false}>
                  <a className="theme-btn full-btn">Overview</a>
                </CustomLink>
              </p>
            ) : (
              rewriteURLs?.['full-scorecard'] && (
                <p className="flex-grow-1 mx-1">
                  <CustomLink href={rewriteURLs?.['full-scorecard']} prefetch={false}>
                    <a className="theme-btn full-btn">Scorecard</a>
                  </CustomLink>
                </p>
              )
            )}
            {sStatusStr === 'scheduled' ? '' : rewriteURLs?.commentary && (
                  <p className="flex-grow-1 mx-1">
                    <CustomLink href={rewriteURLs?.commentary} prefetch={false}>
                      <a className="theme-btn full-btn">Commentary</a>
                    </CustomLink>
                  </p>
            )}
            {rewriteURLs?.news && (
              <p className="flex-grow-1 mx-1">
                <CustomLink href={rewriteURLs?.news} prefetch={false}>
                  <a className="theme-btn full-btn">News</a>
                </CustomLink>
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

FixturesItems.propTypes = {
  fixture: PropTypes.object,
  seriesUrls: PropTypes.object,
  id: PropTypes.string,
  isSeriesShow: PropTypes.bool
}

export default FixturesItems
